<div
  class="layout-wrapper"
  [class.sidebar-open]="showSidebar"
  [class.sidebar-collapsed]="isSidebarCollapsed"
>
  @if (showSidebar) {
    <app-sidebar-wrapper-2
      [collapsed]="isSidebarCollapsed"
      (collapsedChange)="onSidebarCollapsedChange($event)"
    />
  }

  <div
    class="main-wrapper"
    [class.sidebar-open]="showSidebar"
    [class.sidebar-collapsed]="isSidebarCollapsed"
  >
    <lib-toast-container class="layout-vault-toast-host" #vaultToastContainer />
    @if (showHeader) {
      <app-topbar-wrapper-2
        [userName]="userName()"
        [isDarkMode]="isDarkMode()"
        [logoUrl]="logoUrl()"
        [itemsProfileMenu]="itemsProfileMenu()"
        (darkModeToggle)="darkmodeChange()"
        (logout)="logout()"
      />
    }

    @if (showBreadcrumb) {
      <app-breadcrumb-wrapper [items]="breadcrumbItems()" />
    }
    <main class="content">
      <router-outlet></router-outlet>
    </main>
    <app-footer-wrapper [variant]="footerVariant"></app-footer-wrapper>
  </div>
</div>
